/*
 * Public API Surface of ngx-avatar
 */
export * from './lib/avatar.module';
export * from './lib/avatar.component';
export * from './lib/avatar-config';
export * from './lib/avatar.service';
export * from './lib/sources/avatar-source.enum';
